import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';

import { ActivityInfo, OptionalVenue, OverviewInfo } from '../constants';
import API from '../services';

export type ActivityState = {
  optionalVenue: OptionalVenue[];
  currentActivityInfo: ActivityInfo;
  overviewInfo: OverviewInfo;
  isGettingActivityInfo: boolean;
  isGettingOptionalVenue: boolean;
  isEditingActivityInfo: boolean;
  isGettingOverviewInfo: boolean;
};

const initialActivity: ActivityState = {
  optionalVenue: [],
  overviewInfo: {
    activity_space_status: false,
    general_info_status: false,
    player_manage_status: false,
    official_input_number: 0,
    real_login_number: 0,
    self_register_number: 0,
  },
  currentActivityInfo: {} as ActivityInfo,
  isGettingActivityInfo: false,
  isGettingOptionalVenue: false,
  isEditingActivityInfo: false,
  isGettingOverviewInfo: false,
};

export const getActivityCenterInfoById = createAsyncThunk(
  'activity/getActivityCenterInfoById',
  async (
    {
      aid,
    }: {
      aid: string;
    },
    { dispatch, getState }
  ) => {
    const { data } = await API.current!?.activity.getActivityCenterInfoById(aid);
    dispatch(setCurrentActivityInfo(data));
    return data;
  }
);

const activity = createSlice({
  name: 'activity',
  initialState: initialActivity,
  reducers: {
    setCurrentActivityInfo(state, { payload }: PayloadAction<ActivityInfo>) {
      state.currentActivityInfo = payload;
    },
  },
  // eslint-disable-next-line react-func/max-lines-per-function
  extraReducers: builder => {
    builder
      .addCase(getActivityCenterInfoById.pending, state => {
        state.isGettingActivityInfo = true;
      })
      .addCase(getActivityCenterInfoById.fulfilled, (state, action) => {
        state.isGettingActivityInfo = false;
      })
      .addDefaultCase(state => {
        state.isGettingActivityInfo = false;
        state.isGettingOverviewInfo = false;
      });
  },
});

export const { setCurrentActivityInfo } = activity.actions;

export default activity.reducer;
